import { render, staticRenderFns } from "./ContactsListSub.vue?vue&type=template&id=22366eb8&scoped=true&"
import script from "./ContactsListSub.vue?vue&type=script&lang=js&"
export * from "./ContactsListSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22366eb8",
  null
  
)

export default component.exports